import type { TFunction } from "i18next";

export const COMMAND_PALETTE_KEYBOARD_SHORTCUT = "k";

export function isMacPlatform(): boolean {
  return /mac|iphone|ipad/i.test(navigator.userAgent);
}

export function getModifierKeyLabel(t: TFunction): string {
  return isMacPlatform() ? "⌘" : t("KeyboardKeyCtrl");
}

/**
 * Matches ⌘+key on macOS and Ctrl+key elsewhere, so macOS text shortcuts like Ctrl+K keep working.
 */
export function isModifierShortcut(event: KeyboardEvent, key: string): boolean {
  const isModifierPressed = isMacPlatform() ? event.metaKey && !event.ctrlKey : event.ctrlKey && !event.metaKey;

  return isModifierPressed && !event.shiftKey && !event.altKey && event.key.toLowerCase() === key;
}
